import { Button, Input, Modal, Typography } from '@oscar/theme';
import React, { useState } from 'react';
import './style.scss';

const { TextArea } = Input;
const { Title } = Typography;

function Popup(props: any) {
  const {
    title,
    isVisible,
    handleOk,
    handleCancel,
    description,
    tittleContent,
    requireContent,
    maxLength = 250,
    hintTextArea = 'Please write the reason',
    status,
  } = props;

  const [remarkArea, setRemarkArea] = useState('');

  const handleChangeRemark = (e: any) => {
    setRemarkArea(e.target.value);
    // console.log(remarkArea);
  };

  const handleOnCancel = () => {
    setRemarkArea('');
    handleCancel();
  };

  const handleOnOk = () => {
    handleOk(remarkArea);
    // console.log(remarkArea);
    setRemarkArea('');
  };

  return (
    <Modal
      className="popup-custom"
      title={
        <>
          <Title level={3}>{title}</Title>
          <Title level={5} className="description">
            {description}
          </Title>
        </>
      }
      maskTransitionName=""
      visible={isVisible}
      onCancel={handleOnCancel}
      footer={[
        <Button size="middle" key="back" onClick={handleOnCancel}>
          Cancel
        </Button>,
        <Button
          className="btn-submit"
          size="middle"
          key="submit"
          disabled={
            (requireContent && remarkArea.length <= 20) ||
            (requireContent &&
              remarkArea.length <= 20 &&
              status == 'PENDING_PROPOSAL')
          }
          onClick={handleOnOk}
        >
          Confirm
        </Button>,
      ]}
    >
      <Title level={5}>
        {tittleContent}
        {requireContent && <span className="asterisk"> *</span>}
      </Title>
      <TextArea
        className="remark-area"
        rows={4}
        value={remarkArea}
        placeholder={hintTextArea}
        maxLength={maxLength}
        required={requireContent}
        onChange={handleChangeRemark}
      />
      {status == 'PENDING_PROPOSAL' && remarkArea.length <= 20 && (
        <p>Remarks should be greater than 20 character</p>
      )}
      {requireContent && remarkArea.length <= 20 && (
        <p>Remarks should be greater than 20 character</p>
      )}
    </Modal>
  );
}

export default Popup;
